import { Archive } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/Button/Button";

const ArchiveToggleButton = () => {
  const { pathname } = useLocation();
  const onArchive = pathname.endsWith("/archive");
  const target = onArchive
    ? pathname.replace(/\/archive$/, "")
    : `${pathname}/archive`;

  return (
    <Button asChild variant="outline">
      <Link to={target} style={{ textDecoration: "none" }}>
        <Archive />
        {onArchive ? "Back to Active" : "View Archive"}
      </Link>
    </Button>
  );
};

export { ArchiveToggleButton };
